import styled, { css } from "styled-components";

import { colorsPalettes, setElevation, setFontVariant } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

export const StyledIconButton = styled(IconButton)`
    svg path {
        fill: ${colorsPalettes.carbon[200]};
    }
`;

export const StyledThumbsDownIconButton = styled(StyledIconButton)<{ $mirrorIcon: boolean }>`
    ${({ $mirrorIcon }) =>
        $mirrorIcon &&
        css`
            svg {
                transform: scaleX(-1);
            }
        `}
`;

export const SectionRoot = styled(Stack)`
    width: 100%;
    transition: box-shadow 0.2s;

    &:hover {
        ${setElevation("Z1")};
    }
`;

export const TagBadgeLabel = styled.span`
    ${setFontVariant("tag", colorsPalettes.carbon[400])};
    text-transform: uppercase;
    letter-spacing: 0.6px;
`;

export const RowBodyStack = styled(Stack)`
    gap: 16px;
    max-width: min(100%, 740px);
`;

export const SuggestionsSectionLabel = styled.p`
    margin: 0;
    ${setFontVariant("tag", colorsPalettes.carbon[300])};
    text-transform: uppercase;
    letter-spacing: 0.6px;
`;

export const InsightBodyParagraph = styled.p`
    margin: 0;
    ${setFontVariant("body2", colorsPalettes.carbon[400])};
    line-height: 20px;
`;

export const FeedbackToolbar = styled(Flex)`
    flex-direction: row;
    align-items: center;
`;

export const CheckedIconContainer = styled(Flex)`
    align-items: center;
    justify-content: center;
    padding: 4px;
`;

export const InsightsSubtitleReveal = styled.div<{ $visible: boolean }>`
    overflow: hidden;
    flex-shrink: 0;
    max-width: ${({ $visible }) => ($visible ? "320px" : "0")};
    opacity: ${({ $visible }) => ($visible ? 1 : 0)};
    transition:
        max-width 280ms cubic-bezier(0.4, 0, 0.2, 1),
        opacity 220ms ease;
`;

export const InsightsSubtitleText = styled.span`
    display: block;
    white-space: nowrap;
    ${setFontVariant("body2", colorsPalettes.carbon[300])};
    line-height: 16px;
`;

export const InsightsTitleLoaderSlot = styled(Flex)`
    flex: 1;
    align-items: center;
    max-width: 240px;
`;

export const InsightsBodyLoaderRoot = styled.div`
    width: 100%;
`;

export const InsightLoadingRowCard = styled(Flex)`
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding: 12px 8px 12px 16px;
    border: 1px solid ${colorsPalettes.carbon[50]};
    border-radius: 6px;
    background-color: ${colorsPalettes.carbon[0]};
`;
